/**
 * Event Service
 * Historical events service API: a read-only record of what happened inside a Convercus loyalty program. It serves the stored event history for accounts, memberships and users, for coupons, for news posts and for workflows, filtered by subject, date range, originating user and event type. Every endpoint is a paginated read; the service never writes, edits or replays events.
 *
 * The version of the OpenAPI document: v1.0.37758
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IdentifierDto } from './identifier-dto';


export interface AccountIdentifierMergedEventDto { 
    /**
     * Event ID
     */
    _id: string;
    /**
     * Program identifier
     */
    program: string;
    /**
     * Creation timestamp
     */
    createdAt: string;
    /**
     * Username
     */
    userName: string;
    /**
     * Event type
     */
    eventType: AccountIdentifierMergedEventDto.EventTypeEnum;
    /**
     * Interaction ID
     */
    interactionId: string;
    /**
     * Account ID
     */
    accountId: string;
    /**
     * Account event type
     */
    accountEventType: AccountIdentifierMergedEventDto.AccountEventTypeEnum;
    /**
     * Subject information
     */
    subject: IdentifierDto;
    /**
     * Previous identifier account ID
     */
    mergedFromAccountId: string;
}
export namespace AccountIdentifierMergedEventDto {
    export type EventTypeEnum = 'USER_CHANGED' | 'USER_CREATED' | 'REGISTRATIONDATA_CREATED' | 'REGISTRATIONDATA_DELETED' | 'CREDENTIALS_CHANGED' | 'CREDENTIALS_CREATED' | 'NEW_PASSWORD_REQUESTED' | 'NEW_REGISTRATION_REQUEST' | 'MEMBERSHIP_CHANGED' | 'MEMBERSHIP_CREATED' | 'MEMBERSHIP_OPTINS_CHANGED' | 'MEMBERSHIP_TERMINATED' | 'ACCOUNT_CREATED' | 'ACCOUNT_MERGED' | 'ACCOUNT_TERMINATED' | 'FRAUD_ADDED' | 'FRAUD_DELETED' | 'IDENTIFIER_ADDED' | 'IDENTIFIER_MERGED' | 'IDENTIFIER_REMOVED' | 'IDENTIFIER_UPDATED' | 'ACCOUNT_STATUS_LEVEL_CHANGED' | 'ACCOUNT_CUSTOM_PROPERTY_CHANGED' | 'MEMBERSHIP_REMOVED';
    export const EventTypeEnum = {
        UserChanged: 'USER_CHANGED' as EventTypeEnum,
        UserCreated: 'USER_CREATED' as EventTypeEnum,
        RegistrationdataCreated: 'REGISTRATIONDATA_CREATED' as EventTypeEnum,
        RegistrationdataDeleted: 'REGISTRATIONDATA_DELETED' as EventTypeEnum,
        CredentialsChanged: 'CREDENTIALS_CHANGED' as EventTypeEnum,
        CredentialsCreated: 'CREDENTIALS_CREATED' as EventTypeEnum,
        NewPasswordRequested: 'NEW_PASSWORD_REQUESTED' as EventTypeEnum,
        NewRegistrationRequest: 'NEW_REGISTRATION_REQUEST' as EventTypeEnum,
        MembershipChanged: 'MEMBERSHIP_CHANGED' as EventTypeEnum,
        MembershipCreated: 'MEMBERSHIP_CREATED' as EventTypeEnum,
        MembershipOptinsChanged: 'MEMBERSHIP_OPTINS_CHANGED' as EventTypeEnum,
        MembershipTerminated: 'MEMBERSHIP_TERMINATED' as EventTypeEnum,
        AccountCreated: 'ACCOUNT_CREATED' as EventTypeEnum,
        AccountMerged: 'ACCOUNT_MERGED' as EventTypeEnum,
        AccountTerminated: 'ACCOUNT_TERMINATED' as EventTypeEnum,
        FraudAdded: 'FRAUD_ADDED' as EventTypeEnum,
        FraudDeleted: 'FRAUD_DELETED' as EventTypeEnum,
        IdentifierAdded: 'IDENTIFIER_ADDED' as EventTypeEnum,
        IdentifierMerged: 'IDENTIFIER_MERGED' as EventTypeEnum,
        IdentifierRemoved: 'IDENTIFIER_REMOVED' as EventTypeEnum,
        IdentifierUpdated: 'IDENTIFIER_UPDATED' as EventTypeEnum,
        AccountStatusLevelChanged: 'ACCOUNT_STATUS_LEVEL_CHANGED' as EventTypeEnum,
        AccountCustomPropertyChanged: 'ACCOUNT_CUSTOM_PROPERTY_CHANGED' as EventTypeEnum,
        MembershipRemoved: 'MEMBERSHIP_REMOVED' as EventTypeEnum
    };
    export type AccountEventTypeEnum = 'USER_CHANGED' | 'USER_CREATED' | 'REGISTRATIONDATA_CREATED' | 'REGISTRATIONDATA_DELETED' | 'CREDENTIALS_CHANGED' | 'CREDENTIALS_CREATED' | 'NEW_PASSWORD_REQUESTED' | 'NEW_REGISTRATION_REQUEST' | 'MEMBERSHIP_CHANGED' | 'MEMBERSHIP_CREATED' | 'MEMBERSHIP_OPTINS_CHANGED' | 'MEMBERSHIP_TERMINATED' | 'ACCOUNT_CREATED' | 'ACCOUNT_MERGED' | 'ACCOUNT_TERMINATED' | 'FRAUD_ADDED' | 'FRAUD_DELETED' | 'IDENTIFIER_ADDED' | 'IDENTIFIER_MERGED' | 'IDENTIFIER_REMOVED' | 'IDENTIFIER_UPDATED' | 'ACCOUNT_STATUS_LEVEL_CHANGED' | 'ACCOUNT_CUSTOM_PROPERTY_CHANGED' | 'MEMBERSHIP_REMOVED';
    export const AccountEventTypeEnum = {
        UserChanged: 'USER_CHANGED' as AccountEventTypeEnum,
        UserCreated: 'USER_CREATED' as AccountEventTypeEnum,
        RegistrationdataCreated: 'REGISTRATIONDATA_CREATED' as AccountEventTypeEnum,
        RegistrationdataDeleted: 'REGISTRATIONDATA_DELETED' as AccountEventTypeEnum,
        CredentialsChanged: 'CREDENTIALS_CHANGED' as AccountEventTypeEnum,
        CredentialsCreated: 'CREDENTIALS_CREATED' as AccountEventTypeEnum,
        NewPasswordRequested: 'NEW_PASSWORD_REQUESTED' as AccountEventTypeEnum,
        NewRegistrationRequest: 'NEW_REGISTRATION_REQUEST' as AccountEventTypeEnum,
        MembershipChanged: 'MEMBERSHIP_CHANGED' as AccountEventTypeEnum,
        MembershipCreated: 'MEMBERSHIP_CREATED' as AccountEventTypeEnum,
        MembershipOptinsChanged: 'MEMBERSHIP_OPTINS_CHANGED' as AccountEventTypeEnum,
        MembershipTerminated: 'MEMBERSHIP_TERMINATED' as AccountEventTypeEnum,
        AccountCreated: 'ACCOUNT_CREATED' as AccountEventTypeEnum,
        AccountMerged: 'ACCOUNT_MERGED' as AccountEventTypeEnum,
        AccountTerminated: 'ACCOUNT_TERMINATED' as AccountEventTypeEnum,
        FraudAdded: 'FRAUD_ADDED' as AccountEventTypeEnum,
        FraudDeleted: 'FRAUD_DELETED' as AccountEventTypeEnum,
        IdentifierAdded: 'IDENTIFIER_ADDED' as AccountEventTypeEnum,
        IdentifierMerged: 'IDENTIFIER_MERGED' as AccountEventTypeEnum,
        IdentifierRemoved: 'IDENTIFIER_REMOVED' as AccountEventTypeEnum,
        IdentifierUpdated: 'IDENTIFIER_UPDATED' as AccountEventTypeEnum,
        AccountStatusLevelChanged: 'ACCOUNT_STATUS_LEVEL_CHANGED' as AccountEventTypeEnum,
        AccountCustomPropertyChanged: 'ACCOUNT_CUSTOM_PROPERTY_CHANGED' as AccountEventTypeEnum,
        MembershipRemoved: 'MEMBERSHIP_REMOVED' as AccountEventTypeEnum
    };
}


